import { render } from "./ApplicationDetailPage.vue?vue&type=template&id=4174c27b&scoped=true"
import script from "./ApplicationDetailPage.vue?vue&type=script&lang=js"
export * from "./ApplicationDetailPage.vue?vue&type=script&lang=js"

import "./ApplicationDetailPage.vue?vue&type=style&index=0&id=4174c27b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4174c27b"]])

export default __exports__